import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CndzkEntranceApi } from "./apiModel";
export var DataServices = /*#__PURE__*/function () {
  function DataServices(props) {
    this.api = void 0;
    this.config = {
      apiModel: 'mtop',
      applicationType: 'query',
      apiType: 'cndzk',
      businessId: '',
      realm: 'default',
      cnDataVersion: '',
      hideSensitiveDivision: true
    };
    this.config = _extends({}, this.config, props.config || {});
    this.api = {
      get: function get() {}
    };
    if (this.config.apiModel === 'api') {
      var _this$config;
      var _ref = (_this$config = this.config) === null || _this$config === void 0 ? void 0 : _this$config.apiConfig,
        topLevelList = _ref.topLevelList,
        topLevelInfo = _ref.topLevelInfo,
        regionChain = _ref.regionChain,
        children = _ref.children;
      if (!topLevelList || !topLevelInfo || !regionChain || !children) {
        console.error('CnAddressM Error: apiConfig is required');
        return;
      }
    } else if (this.config.apiModel === 'mtop') {
      if (!this.config.businessId) {
        console.error('CnAddressM Error: businessId is required');
        return;
      }
    }
    this.api = new CndzkEntranceApi(_extends({}, this.config));
  }
  var _proto = DataServices.prototype;
  _proto.getTopLevelInfo = /*#__PURE__*/function () {
    var _getTopLevelInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.api.get('topLevelInfo', _extends({}, params));
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function getTopLevelInfo(_x) {
      return _getTopLevelInfo.apply(this, arguments);
    }
    return getTopLevelInfo;
  }();
  _proto.getTopLevelList = /*#__PURE__*/function () {
    var _getTopLevelList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
      var res, r;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.api.get('topLevelList', _extends({}, params));
          case 2:
            res = _context2.sent;
            r = [];
            if (!Array.isArray(res)) res = [];
            res.map(function (i) {
              if (i.regions) {
                r = r.concat(i.regions || []);
              } else {
                r.push(i);
              }
              return null;
            });
            return _context2.abrupt("return", r);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getTopLevelList(_x2) {
      return _getTopLevelList.apply(this, arguments);
    }
    return getTopLevelList;
  }();
  _proto.getRegionChain = /*#__PURE__*/function () {
    var _getRegionChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.api.get('regionChain', _extends({}, params));
          case 2:
            return _context3.abrupt("return", _context3.sent);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function getRegionChain(_x3) {
      return _getRegionChain.apply(this, arguments);
    }
    return getRegionChain;
  }();
  _proto.getChildren = /*#__PURE__*/function () {
    var _getChildren = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return this.api.get('children', _extends({}, params));
          case 2:
            return _context4.abrupt("return", _context4.sent);
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function getChildren(_x4) {
      return _getChildren.apply(this, arguments);
    }
    return getChildren;
  }();
  return DataServices;
}();